export default "__VITE_ASSET__BsJ2OfO5__"